import i18n from '@/utils/i18n';
import OfflineModeIcon from '@assets/icons/offline-mode.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export const BaseOfflineModeBanner: React.FC<Props> = ({
  containerStyle,
  textStyle,
}) => {
  const [styles] = useStyles();

  return (
    <View
      style={[styles.offlineMode, containerStyle]}
      testID="offline-mode-banner"
    >
      <OfflineModeIcon />
      <Text style={[FONTS.primary, styles.offlineModeText, textStyle]}>
        {i18n.t('currently_offline')}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  offlineMode: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
  },
  offlineModeText: {
    color: theme.colors.primary,
  },
}));
